/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompetitionEvidenceType } from './CompetitionEvidenceType';
import {
    CompetitionEvidenceTypeFromJSON,
    CompetitionEvidenceTypeFromJSONTyped,
    CompetitionEvidenceTypeToJSON,
    CompetitionEvidenceTypeToJSONTyped,
} from './CompetitionEvidenceType';

/**
 * 
 * @export
 * @interface MatchEvidenceResponse
 */
export interface MatchEvidenceResponse {
    /**
     * 
     * @type {CompetitionEvidenceType}
     * @memberof MatchEvidenceResponse
     */
    type: CompetitionEvidenceType;
    /**
     * 
     * @type {string}
     * @memberof MatchEvidenceResponse
     */
    url: string;
    /**
     * 
     * @type {number}
     * @memberof MatchEvidenceResponse
     */
    uploadedAt: number;
    /**
     * 
     * @type {string}
     * @memberof MatchEvidenceResponse
     */
    uploadedBy?: string;
}



/**
 * Check if a given object implements the MatchEvidenceResponse interface.
 */
export function instanceOfMatchEvidenceResponse(value: object): value is MatchEvidenceResponse {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('uploadedAt' in value) || value['uploadedAt'] === undefined) return false;
    return true;
}

export function MatchEvidenceResponseFromJSON(json: any): MatchEvidenceResponse {
    return MatchEvidenceResponseFromJSONTyped(json, false);
}

export function MatchEvidenceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchEvidenceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'type': CompetitionEvidenceTypeFromJSON(json['type']),
        'url': json['url'],
        'uploadedAt': json['uploadedAt'],
        'uploadedBy': json['uploadedBy'] == null ? undefined : json['uploadedBy'],
    };
}

export function MatchEvidenceResponseToJSON(json: any): MatchEvidenceResponse {
    return MatchEvidenceResponseToJSONTyped(json, false);
}

export function MatchEvidenceResponseToJSONTyped(value?: MatchEvidenceResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': CompetitionEvidenceTypeToJSON(value['type']),
        'url': value['url'],
        'uploadedAt': value['uploadedAt'],
        'uploadedBy': value['uploadedBy'],
    };
}

